<template>
  <Breadcrumbs
      title="Stock Allocation"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Stock Allocation', path: '/stock-allocation' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <stockAllocationTable/>

    </div>
  </div>
</template>


<script>
import stockAllocationTable from '@/pages/stock/stock_allocation/stockAllocationTable.vue';

export default {
  components: {
    stockAllocationTable
  }
}
</script>